<div
  [cdkCopyToClipboard]="copiedValue"
  (click)="commonMessagesService.showCopiedToClipboardMessage()"
  class="cursor-pointer flex align-items-center"
  pRipple
>
  <p class=" mb-0 select-none">
    {{value}}
  </p>
  <i
    *ngIf="showIcon"
    (click)="commonMessagesService.showCopiedToClipboardMessage()"
    class="pi pi-clone ml-2 select-none"
  ></i>
</div>
